'use strict';

/**
 * Component for the proper name
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var Html = require('base/Colido.Html');

var template = require('../../templates/components/field-scanners.hbs');

var ScannersComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    ui: {
        'clearTagButton': '[data-action="clear-tag"]',
        'setTagButton': '[data-action="set-tag"]',
        'scannersSelect': '[data-action="select-active-scanner"]',
        'activeTagsHint': '.active-tags-hint',
        'tagIcon': '.tag-icon',
        'tagHint': '.tag-hint',
    },

    events: {
        'click @ui.clearTagButton': 'clearTag',
        'click @ui.setTagButton': 'setTag',
        'change @ui.scannersSelect': 'onChangeActiveScanner',
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        value: function() {
            return this.value;
        },

        isGroupChild: function() {
            return this.getOption('isGroupChild');
        },

        scanners: function() {
            return this.scanners;
        },

        activeScanner: function() {
            return this.activeScanner;
        },
    },

    initialize: function(options) {
        LayoutView.prototype.initialize.apply(this, arguments);

        var field = this.getOption('field');

        this.value = this.model.get(field.name);
        this.scanners = App.radio().request('scanners:collection');

        if (this.scanners.length) {
            this.activeScanner = this.scanners.at(0);
        }
    },

    clearTag: function(event) {
        event.preventDefault();

        this.value = '';
        this.render();
    },

    setTag: function(event) {
        event.preventDefault();

        var tags = this.activeScanner.get('tags');

        this.value =  tags.length ? tags[0] : '';
        this.render();
    },

    onChangeActiveScanner: function(event) {
        var selectedScannerId = this.ui.scannersSelect.val();
        var selectedScanner = this.scanners.get(selectedScannerId)

        this.selectActiveScanner(selectedScanner);
    },

    selectActiveScanner: function(scanner) {
        if (!scanner) {
            return;
        }

        this.stopListening(this.activeScanner);

        this.activeScanner = scanner;

        this.listenTo(this.activeScanner, 'change', this.updateTagsFromScanner);

        this.updateTagsFromScanner(this.activeScanner);
    },

    onRender: function() {
        if (!this.value) {
            this.selectActiveScanner(this.activeScanner);
        }
    },

    updateTagsFromScanner: function(scanner) {
        if (!scanner || scanner !== this.activeScanner || this.value) {
            return;
        }

        var tags = scanner.get('tags');

        var scannerStatusMessage = '';
        var isSubmitButtonDisabled = true;
        var scannerTagIcon = '';

        if (tags.length === 0) {
            scannerTagIcon = Html.icon('scanner-tag', null, 'no-tag');
            scannerStatusMessage = App.t('collection::scanners:objects:detail:status:no-tag');
        } else if (tags.length === 1) {
            if (this.isTagUnused(tags)) {
                scannerTagIcon = Html.icon('scanner-tag', null, 'valid-tag');
                scannerStatusMessage = App.t('collection::scanners:objects:detail:status:valid-tag');
                isSubmitButtonDisabled = false;
            } else {
                scannerTagIcon = Html.icon('scanner-tag', null, 'used-tag');
                scannerStatusMessage = App.t('collection::scanners:objects:detail:status:used-tag');
            }
        } else {
            scannerTagIcon = Html.icon('scanner-tag', null, 'too-many-tags');
            scannerStatusMessage = App.t('collection::scanners:objects:detail:status:too-many-tags');
        }

        this.ui.tagIcon.html(scannerTagIcon).attr('title', tags.join(', '));
        this.ui.tagHint.html(scannerStatusMessage);

        this.ui.setTagButton.prop('disabled', isSubmitButtonDisabled);
    },

    isTagUnused: function(tags) {
        var objectId = this.model.collection.getObjectIdsByScannerTags(tags);

        //@todo check all catalogs of a user for this tag

        //It's ok if the tag was used for the same object before
        return objectId.length === 0 || objectId[0] === this.model.id;
    },

    /**
     * Resets the states and data of the component
     */
    reset: function() {
        this.render();
    },

    getData: function() {
        var data = {};
        var field = this.getOption('field');

        data[field.name] = this.$('[name="' + field.name + '"]').val().trim();

        return data;
    },
});

module.exports = ScannersComponent;